import { Button, Stack, Typography } from "@mui/material";
import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import questAns from "../assets/svgGame/quest_answer.svg"
import questNum from "../assets/svgGame/quest_num.svg"
import Frame from "../components/Frame";
import FeedbackOverlay from "../components/FeedbackOverlay";

export default function Question({ riddle, step, handleNext, sendAddStat }) {
    const { t } = useTranslation();
    const [feedbackCorrect, setFeedbackCorrect] = useState(false);
    const [open, setOpen] = useState(false);
    const [shuffledAnswers, setShuffledAnswers] = useState([]);

    useEffect(() => {
        if (riddle?.answers) {
            const shuffled = [...riddle.answers].sort(() => Math.random() - 0.5);
            setShuffledAnswers(shuffled);
        }
    }, [riddle]);

    const handleAnswerClick = (answer) => {
        if (riddle && riddle.id && sendAddStat) {
            sendAddStat(riddle.id, answer.isCorrect ?? false);
        }

        if (answer.isCorrect) {
            setFeedbackCorrect(true);
            setTimeout(() => {
                handleNext();
            }, 1550);

        } else {
            setFeedbackCorrect(false);
        }
        setOpen(true);
    };

    return (
        <>
            <Frame step={step}>
                <Stack
                    justifyContent={'space-between'}
                    height='100%'
                    spacing={1}
                >
                    <Typography
                        color={'white'}
                        sx={{
                            fontSize: {
                                xs: '0.9rem',
                                sm: '1.1rem',
                                md: '1.3rem'
                            }
                        }}>
                        {riddle?.question}
                    </Typography>

                    <Stack width={'100%'} spacing={1}>
                        {shuffledAnswers.map((answer, index) => (
                            <Button
                                key={index}
                                variant="text"
                                disableRipple={true}
                                disableFocusRipple={true}
                                onClick={() => handleAnswerClick(answer)}
                                sx={{
                                    padding: 0,
                                    height: 40,
                                }}
                            >
                                <Stack
                                    direction='row'
                                    alignItems={'center'}
                                    width='100%'
                                    height='100%'
                                >
                                    <Stack
                                        sx={{
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            backgroundImage: `url(${questNum})`,
                                            backgroundSize: 'contain',
                                            backgroundPosition: 'center',
                                            backgroundRepeat: 'no-repeat',
                                            width: '30%',
                                            height: '100%',
                                        }}
                                    >
                                        <Typography
                                            fontWeight='bold'
                                            color="textFrame"
                                            sx={{
                                                fontSize: {
                                                    xs: '0.9rem',
                                                    sm: '1.1rem',
                                                    md: '1.3rem'
                                                }
                                            }}
                                        >
                                            {index + 1}
                                        </Typography>
                                    </Stack>

                                    <Stack
                                        sx={{
                                            justifyContent: 'center',
                                            backgroundImage: `url(${questAns})`,
                                            backgroundSize: 'contain',
                                            backgroundPosition: 'center',
                                            // bgcolor: 'red',
                                            backgroundRepeat: 'no-repeat',
                                            width: '100%',
                                            height: '100%',
                                        }}
                                    >
                                        <Typography
                                            fontWeight='bold'
                                            color="textFrame"
                                            sx={{
                                                fontSize: {
                                                    xs: '0.9rem',
                                                    sm: '1.1rem',
                                                    md: '1.3rem'
                                                }
                                            }}
                                        >
                                            {answer.text}
                                        </Typography>
                                    </Stack>
                                </Stack>
                            </Button>
                        ))}
                    </Stack>
                </Stack>
            </Frame>

            <FeedbackOverlay
                isOpen={open}
                setIsOpen={setOpen}
                message={feedbackCorrect ? riddle?.rightAnswer : t('WRONG_ASNWER')}
                isSuccess={feedbackCorrect}
            />
        </>
    );
}